import { render, staticRenderFns } from "./BdSummary.vue?vue&type=template&id=7530779a&"
import script from "./BdSummary.vue?vue&type=script&lang=js&"
export * from "./BdSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports